import { useCallback } from 'react'
import { useAppDispatch } from '../../../hooks/redux'
import { signIn, signUp, signOut, signInWithGoogle, clearError } from '../lib/slice'
import { LoginCredentials, SignUpCredentials } from '../../../services/AuthService'

export const useAuthActions = () => {
  const dispatch = useAppDispatch()

  const handleSignIn = useCallback(async (credentials: LoginCredentials) => {
    const result = await dispatch(signIn(credentials))
    if (signIn.fulfilled.match(result)) {
      // NO navegar aquí - se manejará por el AuthProvider
      return { success: true, error: null }
    } else {
      return { success: false, error: result.payload as string }
    }
  }, [dispatch])

  const handleSignUp = useCallback(async (credentials: SignUpCredentials) => {
    const result = await dispatch(signUp(credentials))
    if (signUp.fulfilled.match(result)) {
      // NO navegar aquí - se manejará por el AuthProvider
      return { success: true, error: null }
    } else {
      return { success: false, error: result.payload as string }
    }
  }, [dispatch])

  const handleSignOut = useCallback(async () => {
    const result = await dispatch(signOut())
    if (signOut.fulfilled.match(result)) {
      // NO navegar aquí - se manejará por el AuthProvider
      return { success: true, error: null }
    } else {
      return { success: false, error: result.payload as string }
    }
  }, [dispatch])

  const handleGoogleSignIn = useCallback(async (uri: string | undefined) => {
    const result = await dispatch(signInWithGoogle(uri))
    if (signInWithGoogle.fulfilled.match(result)) {
      // Google auth will redirect, so we don't navigate here
      return { success: true, error: null }
    } else {
      return { success: false, error: result.payload as string }
    }
  }, [dispatch])

  const handleClearError = useCallback(() => {
    dispatch(clearError())
  }, [dispatch])

  return {
    signIn: handleSignIn,
    signUp: handleSignUp,
    signOut: handleSignOut,
    signInWithGoogle: handleGoogleSignIn,
    clearError: handleClearError,
  }
}